module.exports = __webpack_public_path__ + "img/img-scholarship@3x.ae06df75.jpg";